<script>
  import { onDestroy } from "svelte";
  import { lang } from "../lib/stores";
  let selectedLang;
  const unsubscribe = lang.subscribe((value) => selectedLang = value);
  onDestroy(unsubscribe);
</script>

<section class="familyStats">
  <blockquote>
    <p>
      <em>Mio padre</em> era un grande farabutto<br />
      <em>Mia madre</em> per crescermi ha fatto di tutto, non male
    </p>
    <p><small>Ricchi dentro, Album, 2017</small></p>
  </blockquote>

  <div class="p">
    <p>
      {#if selectedLang === 'it'}
        Abbiamo già accennato al rapporto particolare di Ghali con i genitori.
        Dalle sue interviste emerge tutto il <a
          href="https://www.vikingsomusic.com/post/ghali-a-2-anni-persi-mio-padre-per-colpa-del-carcere"
          target="_blank">dolore provato per essere cresciuto senza un padre</a
        >,
        <a
          href="https://www.alfemminile.com/attualita/ghali-compie-31-anni-post-instagram-il-mio-piu-grande-peccato-non-avere-fatto-pace-con-mio-padre/"
          target="_blank">la sua rabbia nei suoi confronti</a
        >, e il
        <a
          href="https://www.vanityfair.it/article/ghali-sfogo-social-31-anni-come-se-in-questo-giorno-affrontassi-mio-piu-grande-peccato-non-aver-fatto-pace-con-mio-padre"
          target="_blank">disagio interiore che ora affronta</a
        > a causa della situazione.
      {:else}
        We have already mentioned Ghali's particular relationship with his parents. From his interviews emerges all the <a href="https://www.vikingsomusic.com/post/ghali-a-2-anni-persi-mio-padre-per-colpa-del-carcere" target="_blank">pain he felt for growing up without a father</a> ,
      <a href="https://www.alfemminile.com/attualita/ghali-compie-31-anni-post-instagram-il-mio-piu-grande-peccato-non-avere-fatto-pace-con-mio-padre/" target="_blank">his anger towards him</a> , and the
      <a href="https://www.vanityfair.it/article/ghali-sfogo-social-31-anni-come-se-in-questo-giorno-affrontassi-mio-piu-grande-peccato-non-aver-fatto-pace-con-mio-padre" target="_blank">discomfort he now faces</a> because of the situation.
      {/if}
    </p>
    <blockquote>
      <p>
        <em>Mio padre con la cocaina</em>, io con la marijuana<br />
        Dunque gira e rigira torno nella mia savana<br />
        <em>Mia madre è una regina</em>, ma son figlio di puttana<br />
        Conosco chi ti sbuccerebbe come una banana<br />
      </p>
      <p><small>Optional, Lunag Vita a Sto, 2017</small></p>
    </blockquote>
    <p>
      {#if selectedLang === 'it'}
        Per la madre, invece, ha sempre avuto
        <a href="https://www.instagram.com/ghali/" target="_blank"
          >solo parole d'affetto</a
        >. Non è un mistero che con i primi soldi guadagnati Ghali abbia regalato
        a sé e alla mamma un nuovo appartamento, più grande, nel quale finalmente
        <a
          href="https://www.today.it/gossip/vip/ghali-madre-padre-galera.html"
          target="_blank">ognuno dei due ha una stanza tutta per sé</a
        >. Il
        <a
          href="https://www.cosmopolitan.com/it/star/televisione/a46711987/sanremo-2024-finale-ghali-mamma-amel-dedica/"
          target="_blank">saluto dedicato dal rapper alla madre</a
        >
        in platea durante la
        <a
          href="https://www.corriere.it/spettacoli/festival-sanremo/notizie/chi-mamma-ghali-sempre-presente-platea-all-ariston-00ef7e04-c866-11ee-bbeb-1a8d2ebebe3f.shtml"
          target="_blank">serata finale di Sanremo 2024</a
        >
        ha suscitato grandi emozioni, così come l'<a
          href="https://www.vanityfair.it/article/ghali-mamma-ammalata-cancro-terza-volta-ha-subito-operazione-ho-pensato-di-smettere-di-fare-musica-a-che-servono-soldi-e-successo"
          target="_blank">annuncio della sua malattia</a
        >. <em>Ma questo dualismo è visibile anche nei suoi testi?</em>
      {:else}
        For his mother, however, he has always had
        <a href="https://www.instagram.com/ghali/" target="_blank">only words of affection</a> . It is no mystery that with the first money he earned, Ghali gave himself and his mother a new, larger apartment, in which finally
        <a href="https://www.today.it/gossip/vip/ghali-madre-padre-galera.html" target="_blank">each of them has a room all to themselves</a> . The
        <a href="https://www.cosmopolitan.com/it/star/televisione/a46711987/sanremo-2024-finale-ghali-mamma-amel-dedica/" target="_blank">greeting dedicated by the rapper to his mother</a> 
        in the audience during the
        <a href="https://www.corriere.it/spettacoli/festival-sanremo/notizie/chi-mamma-ghali-sempre-presente-platea-all-ariston-00ef7e04-c866-11ee-bbeb-1a8d2ebebe3f.shtml" target="_blank">final evening of Sanremo 2024</a> 
        aroused great emotions, as did the <a href="https://www.vanityfair.it/article/ghali-mamma-ammalata-cancro-terza-volta-ha-subito-operazione-ho-pensato-di-smettere-di-fare-musica-a-che-servono-soldi-e-successo" target="_blank">announcement of her illness</a>.
        <em>But is this dualism also visible in his lyrics?</em>
      {/if}
    </p>
  </div>
  <blockquote>
    <p>
      Tanto poi ci estingueremo come i dodo<br />
      Polizia, polizia<br />
      <em>Prima arrestano mio padre e poi mi chiedono la foto</em>
    </p>
    <p><small>Ora d'aria, Album, 2017</small></p>
  </blockquote>
</section>

<style>
  .familyStats {
    display: block;
  }
</style>
